export default __webpack_public_path__ + "static/media/join.844cc453.png";